module.exports = __webpack_public_path__ + "img/slide13.96f7fb39.png";